import { render, staticRenderFns } from "./DraftsView.vue?vue&type=template&id=0fe01179&"
import script from "./DraftsView.vue?vue&type=script&lang=ts&"
export * from "./DraftsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports